import React from 'react';
import { Box, Slider, Typography } from '@mui/material';

interface ChunkSliderProps {
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  'data-testid'?: string;
}

const ChunkSlider: React.FC<ChunkSliderProps> = ({
  value,
  onChange,
  min,
  max,
  'data-testid': testId,
}) => {
  const handleChange = (_: Event, newValue: number | number[]) => {
    onChange(newValue as number);
  };

  return (
    <Box sx={{ minWidth: 200, flex: 1 }}>
      <Typography variant="body2" gutterBottom>
        Chunks: {value}
      </Typography>
      <Slider
        value={value}
        onChange={handleChange}
        min={min}
        max={max}
        step={1}
        marks
        aria-label="Number of chunks"
        aria-valuetext={`${value} chunks`}
        data-testid={testId}
      />
    </Box>
  );
};

export default ChunkSlider;
